import { render, staticRenderFns } from "./AssistFab.vue?vue&type=template&id=5c28a28a&scoped=true"
import script from "./AssistFab.vue?vue&type=script&lang=ts"
export * from "./AssistFab.vue?vue&type=script&lang=ts"
import style0 from "./AssistFab.vue?vue&type=style&index=0&id=5c28a28a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c28a28a",
  null
  
)

export default component.exports